import { ApiError } from './api';
import { mapApiError, type MappedApiError } from './apiError.mapper';

export { mapApiError, type MappedApiError };

/** Map internal auth/risk codes to shopper-safe copy. */
const CODE_MESSAGES: Record<string, string> = {
  DEVICE_DRIFT: 'Your session is no longer valid on this device. Please sign in again.',
  AUTH_STEP_UP_REQUIRED: 'Please confirm your identity and try again.',
  RISK_STEP_UP_REQUIRED: 'Please confirm your identity and try again.',
  STEP_UP_REQUIRED: 'Please confirm your identity and try again.',
  RISK_DENIED: 'This action is not available right now. Please contact support if this continues.',
  RISK_MANUAL_REVIEW_REQUIRED: 'Your request is under review. We will notify you when it completes.',
  AUTH_FIREBASE_DISABLED: 'This sign-in method is not available yet. Please use email and password.',
  GUEST_CHECKOUT_SIGN_IN_REQUIRED:
    'An account already exists for this email. Sign in to checkout and earn rewards.'
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof ApiError) {
    const fromCode = error.code ? CODE_MESSAGES[error.code] : undefined;
    if (fromCode) return fromCode;
    const mapped = mapApiError(error, fallback);
    if (mapped.userMessage && mapped.userMessage !== fallback) return mapped.userMessage;
    const message = error.message.trim();
    if (message) return message;
  }

  if (error instanceof Error) {
    const message = error.message.trim();
    if (message) return message;
  }

  return fallback;
};

